import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';

import * as ResourceApi from 'api/resources';
import * as ResourceActions from 'resources/actions';
import * as UserActions from './actions';
import * as UserApi from 'api/user';
import {filterOptionsFactory, sortOptionsFactory} from 'viewOptions/factories';
import {makeGetAllBreaksByChallengeIdAction} from "pages/EditBreak/epics";

const loginEpic = (action$) => action$.ofType(UserActions.Types.LOGIN)
    .mergeMap((action) => UserApi.login(action.username, action.password)
        .map((response) => UserActions.loginSuccessAction(response.response.accessToken, response.response.user))
        .catch((err, caught) => Observable.of(UserActions.loginFailedAction(err.response)))
    );

const loginSuccessEpic = (action$, store) => action$.ofType(UserActions.Types.LOGIN_SUCCESS)
    .mergeMap((action) => {
        const emptySorts = sortOptionsFactory();
        const emptyFilters = filterOptionsFactory();

        const resources = ['Filter', 'Site', 'Group'].map(type => ResourceActions.getAllResourcesAction(
            ResourceApi.Types[type], emptySorts, emptyFilters
        ));

        return Observable.of(
            ResourceActions.getResourcePageAction(ResourceApi.Types.Challenge, 20),
            ...resources,
            makeGetAllBreaksByChallengeIdAction(store.getState().editBreak.selectedChallengeId)
        );
    });

const logoutEpic = (action$, store) => action$.ofType(UserActions.Types.LOGOUT)
    .mergeMap((action) => UserApi.logout()
        .map((response) => UserActions.logoutSuccessAction())
        .catch(err => Observable.of(UserActions.logoutFailedAction()))
    );

const resetPasswordEpic = (action$) => action$.ofType(UserActions.Types.RESET_PASSWORD)
      .mergeMap(({data}) => UserApi.resetPassword(data.email, data.language)
            .map((response) => UserActions.resetPasswordSuccessAction())
            .catch((err, caught) => Observable.of(UserActions.resetPasswordFailedAction(err.response)))
    );

export default [
    loginEpic,
    loginSuccessEpic,
    logoutEpic,
    resetPasswordEpic
];



// WEBPACK FOOTER //
// ./public/pages/Login/epics.js